<template>
  <div class="view-container">
    <!-- Show spash screen -->
    <div v-if="showLoader">
      <app-loader :fadeoutLoader="fadeoutLoader"></app-loader>
    </div>
    <div v-if="fadeoutLoader"></div>
    <div class="pay-container">
      <img
        v-if="!invoice && checkedForInvoice == false"
        src="@/assets/Loading_icon.gif"
        class="loader-icon"
        width="250"
        height="150"
        alt="Loading..."
      />
      <div v-else>
        <div v-if="!invoice" class="center">
          <h3>Invoice could not be found.</h3>
          <p>Please make sure the correct invoice was selected.</p>
        </div>
        <div v-else-if="!invoice.isSupported" class="center">
          <h3>Oops!</h3>
          <p>This branch does not support SnapnTab...yet</p>
        </div>
        <div v-else class="center">
          <h2>{{ branch.name }}</h2>
          <div class="contact-details-container col-md-12">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6 left">
              <span style="display: block">
                {{ branch.address }}
              </span>
              <span style="display: block">
                {{ branch.province }}
              </span>
              <span style="display: block">
                {{ branch.areaCode }}
              </span>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6 right">
              <span style="display: block">
                {{ branch.contactNo }}
              </span>
              <span style="display: block">
                {{ branch.emailAddress }}
              </span>
              <span style="display: block">
                Inv: {{ invoice.referenceNo }}
              </span>
            </div>
          </div>
          <hr />
          <div class="receipt-container">
            <div class="totals-container">
              <table>
                <tr>
                  <td>Subtotal:</td>
                  <td name="sub-total">
                    {{
                      toThousandSeparatedDisplayValue(
                        invoice.goodsAmount.toFixed(2)
                      )
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Tip:</td>
                  <td>
                    <input
                      type="number"
                      name="tip"
                      class="form-control"
                      v-model.number="tipValue"
                      min="0.00"
                      step="0.01"
                      @blur="validateTip($event)"
                      @change="validateTip($event)"
                    />
                  </td>
                </tr>
                <tr class="tips">
                  <td class="right" colspan="2">
                    <button class="btn btn-sm" @click="calculateTip">
                      <i id="arrow-left" class="fa fa-arrow-left" />&nbsp;<span
                        >5%</span
                      >
                    </button>
                    <button class="btn btn-sm" @click="calculateTip">
                      <span>10%</span>
                    </button>
                    <button class="btn btn-sm" @click="calculateTip">
                      <span>15%</span>&nbsp;<i
                        id="arrow-right"
                        class="fa fa-arrow-right"
                      />
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>Total:</td>
                  <td>
                    <input
                      type="number"
                      name="total"
                      class="form-control"
                      v-model.number="totalValue"
                      :min="invoice.goodsAmount"
                      step="0.01"
                      @blur="validateTotal($event)"
                      @change="validateTotal($event)"
                    />
                  </td>
                </tr>
              </table>
            </div>
            <button
              v-on:click="payNow"
              class="btn"
              :style="{
                'background-color': $franchiseAccentColor,
                color: 'white',
              }"
            >
              Pay Now
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- Scripts -->
<script>
import loaderPartial from "@/components/LoaderPartial.vue";
import { splashScreen } from "@/mixins/splashScreen";

export default {
  name: "Pay",
  components: {
    "app-loader": loaderPartial,
  },
  mixins: [splashScreen],
  data() {
    return {
      franchiseID: this.$route.query.fid,
      branchID: this.$route.query.bid,
      invoiceNo: this.$route.query.invNo,
      invoice: null,
      checkedForInvoice: false,
      branch: null,
      tip: 0.0,
      total: 0.0,
    };
  },
  computed: {
    tipValue: {
      get: function () {
        return this.tip.toFixed(2);
      },
      set: function (newValue) {
        this.tip = parseFloat(newValue);
      },
    },
    totalValue: {
      get: function () {
        return this.total.toFixed(2);
      },
      set: function (newValue) {
        this.total = parseFloat(newValue);
      },
    },
  },
  created() {
    var _self = this;

    var paymentData = {
      FranchiseID: _self.franchiseID,
      BranchID: _self.branchID,
      ReferenceNo: _self.invoiceNo,
    };
    _self.initialize().then(function () {
      _self.$ooApi.orders.branches.get
        .v1(paymentData)
        .then(function (response) {
          _self.branch = response.data;
        })
        .then(function () {
          _self.$payApi.pay.payment.get
            .v1(paymentData)
            .then(function (response) {
              if (response.data != null && response.data.purchaseOrderStatusName != "InProgress")
                _self.$router.push({
                  path: "TransactionCompleted",
                  query: {
                    fid: paymentData.FranchiseID,
                    bid: paymentData.BranchID,
                    invNo: paymentData.ReferenceNo,
                  },
                });
              _self.invoice = response.data;
              _self.checkedForInvoice = true;

              if (_self.invoice) _self.total = _self.invoice.goodsAmount;
            });
        });
    });
  },
  methods: {
    initialize: function () {
      return new Promise((resolve, reject) => {
        var _self = this;

        _self.$franchiseID = _self.franchiseID;
        _self.$branchID = _self.branchID;

        if (!_self.franchiseID || !_self.branchID) {
          _self.clearComputed;
          _self.$router.push("Franchise");
        }

        _self.showSplashScreen();

        var franchiseData = {
          FranchiseID: _self.franchiseID,
          FranchiseName: "",
        };
        _self.$ooApi.orders.franchises.get
          .v1(franchiseData)
          .then(function (result) {
            var data = result.data;
            _self.$franchiseID = data.id;
            _self.$franchiseName = data.name;
            _self.$franchiseUrlFriendlyOrderName = data.urlFriendlyOrderName;
            _self.$franchiseLogoUrl = data.franchiseLogoURL;
            _self.$franchiseBannerUrl = data.bannerImageURL;
            _self.$franchiseAccentColor = data.accentColor;
            _self.$franchiseAccentColor = data.accentColor;
            _self.$lastSessionDate = new Date();

            _self.$payFID = data.id;
            _self.$payBID = _self.branchID;
            _self.$payInvNo = _self.invoiceNo;

            _self.initOoApi(_self.$franchiseID);
            _self.initPayApi(_self.$franchiseID);
            _self.hideSplashScreen();
          })
          .then(function () {
            _self.hideSplashScreen();
            resolve();
          })
          .catch((error) => {
            _self.hideSplashScreen();
            reject(error);
          });
      });
    },
    payNow: function () {
      var _self = this;
      var paymentData = {
        FranchiseID: _self.franchiseID,
        BranchID: _self.branchID,
        ReferenceNo: _self.invoiceNo,
        Amount: _self.total,
        Gratuity: _self.tip,
      };
      _self.$payApi.pay.payment.v1(paymentData).then(function (response) {
        if (!response.success) throw new Error(response.message);

        var result = response.data;
        _self.paymentProvider = result.paymentProvider;
        _self.paymentReference = result.paymentReference;
        _self.branchID = result.branchID;
        _self.paymentKey = result.paymentKey;

        if (!result.paymentProvider) window.location.href = result.redirectTo;
        else
          _self.redirect(result.redirectTo, {
            PaymentProvider: result.paymentProvider,
            PaymentReference: result.paymentReference,
            BranchID: result.branchID,
            PaymentKey: result.paymentKey,
          });
      });
    },
    validateTip: function (e) {
      var _self = this;
      var value = document.getElementsByName("tip")[0].value;

      if (value == "" || parseFloat(value) < parseFloat(e.target.min)) {
        _self.tipValue = parseFloat(e.target.min).toFixed(2);
      } else _self.tipValue = parseFloat(value).toFixed(2);

      _self.totalValue = (
        parseFloat(
          document
            .getElementsByName("sub-total")[0]
            .textContent.replaceAll(",", "")
        ) + parseFloat(_self.tipValue)
      ).toFixed(2);
    },
    validateTotal: function (e) {
      var _self = this;
      var value = document.getElementsByName("total")[0].value;
      if (value == "" || parseFloat(value) < parseFloat(e.target.min))
        _self.totalValue = parseFloat(e.target.min);
      else _self.totalValue = parseFloat(value).toFixed(2);

      _self.tipValue = (
        parseFloat(value) -
        parseFloat(
          document
            .getElementsByName("sub-total")[0]
            .textContent.replaceAll(",", "")
        )
      ).toFixed(2);
    },
    calculateTip: function (e) {
      var _self = this;
      var target = e.target;
      if (e.target.id.startsWith("arrow")) target = e.target.parentElement;

      var value = parseFloat(target.textContent.slice(0, -1));
      var subTotal = parseFloat(
        document
          .getElementsByName("sub-total")[0]
          .textContent.replaceAll(",", "")
      );
      var tips = parseFloat((subTotal * (value / 100)).toFixed(2));
      _self.tipValue = tips;
      _self.totalValue = subTotal + tips;
      _self.scrollTips(value + "%");
    },
    scrollTips: function (selected) {
      var buttons = document.querySelectorAll(".tips button");
      var arrows = document.querySelectorAll(".tips i");
      if (buttons[0].textContent.trim() == selected && selected != "0%") {
        buttons.forEach((element) => {
          element.textContent =
            parseFloat(element.textContent.slice(0, -1)) - 5 + "%";
        });
        arrows[1].style.display = "inline";
        buttons[0].innerHTML = "&nbsp;" + buttons[0].innerHTML;
        buttons[0].prepend(arrows[0]);
        buttons[1].focus();
        buttons[2].innerHTML = buttons[2].innerHTML + "&nbsp;";
        buttons[2].append(arrows[1]);
      } else if (
        buttons[2].textContent.trim() == selected &&
        selected != "100%"
      ) {
        buttons.forEach((element) => {
          element.textContent =
            parseFloat(element.textContent.slice(0, -1)) + 5 + "%";
        });
        arrows[0].style.display = "inline";
        buttons[0].innerHTML = "&nbsp;" + buttons[0].innerHTML;
        buttons[0].prepend(arrows[0]);
        buttons[1].focus();
        buttons[2].innerHTML = buttons[2].innerHTML + "&nbsp;";
        buttons[2].append(arrows[1]);
      } else if (selected == "0%") arrows[0].style.display = "none";
      else if (selected == "100%") arrows[1].style.display = "none";
    },
    numberWithCommas: function (x) {
      var parts = x.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    },
  },
};
</script>
<style scoped>
.pay-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.pay-container > div {
  width: 100%;
}
.pay-container .contact-details-container {
  display: inline-flex;
}
.receipt-container {
  max-width: 320px;
  display: inline-block;
  position: relative;
}
.receipt-container > button {
  position: absolute;
  right: 35px;
}
table {
  border-collapse: separate;
  border-spacing: 15px 5px;
  width: 100%;
  max-width: 320px;
  padding: 0 19px;
  margin: auto;
}
table tr td:first-child:not([colspan="2"]) {
  text-align: left;
  width: 80px;
}
table tr:first-child td:last-child {
  padding-right: 13px;
}
table tr td:last-child:not([colspan="2"]),
table tr td:last-child input {
  text-align: right;
}
table tr td button {
  background-color: #428bca;
  color: #fff;
  margin: 0 2px;
}
</style>
